module.exports = __webpack_public_path__ + "media/tv-tv2-casovni-zamik_compressed.952d330b.mp4";